

export default abstract class FunctionConstants {
    static readonly ADD_AWAITING_USER = "addAwaitingUser"
    static readonly CREATE_EMPLOYER = "createEmployer"
    static readonly CREATE_EMPLOYEE = "createEmployee"
}